import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { PERMISSIONS } from '@lms/shared-types';
import { usePermissions } from '@/hooks/usePermissions';
import { api } from '@/lib/api';

interface ContractDetailStatus {
  status: string;
}

interface PendingResponse {
  data: { id: string } | null;
}

/** Oculta PrimaryNav en la vista de firma para evitar bypass del flujo obligatorio. */
export function useContractSigningNavHidden(): boolean {
  const { pathname } = useLocation();
  const match = pathname.match(/^\/mis-contratos\/([^/]+)$/);
  const contractId = match?.[1];
  const { hasPermission } = usePermissions();
  const canViewContracts = hasPermission(PERMISSIONS.MIS_CONTRATOS_VER);

  const { data: pending } = useQuery({
    queryKey: ['student', 'contracts', 'pending'],
    queryFn: () => api<PendingResponse>('/student/contracts/pending'),
    enabled: Boolean(contractId) && canViewContracts,
    staleTime: 0,
  });

  const { data: detail, isLoading } = useQuery({
    queryKey: ['student', 'contracts', contractId],
    queryFn: () => api<ContractDetailStatus>(`/student/contracts/${contractId}`),
    enabled: Boolean(contractId) && canViewContracts,
    staleTime: 30_000,
  });

  if (!contractId || !canViewContracts) {
    return false;
  }

  if (isLoading) {
    return pending?.data?.id === contractId;
  }

  return detail?.status === 'pending_acceptance';
}
